import { useState, useEffect } from 'react';
import { Product } from '../types';

const MAX_RECENT_ITEMS = 5;
const STORAGE_KEY = 'carbon_cases_recent_products';

export const useRecentlyViewed = () => {
    const [recentlyViewed, setRecentlyViewed] = useState<Product[]>([]);

    // Load from local storage
    useEffect(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored) {
                setRecentlyViewed(JSON.parse(stored));
            }
        } catch (error) {
            console.error('Error loading recently viewed products', error);
        }
    }, []);

    const addToRecentlyViewed = (product: Product) => {
        setRecentlyViewed(prev => {
            const filtered = prev.filter(p => p.id !== product.id);
            const updated = [product, ...filtered].slice(0, MAX_RECENT_ITEMS);

            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
            } catch (error) {
                console.error('Error saving recently viewed products', error);
            }

            return updated;
        });
    };

    return { recentlyViewed, addToRecentlyViewed };
};
